import React, { useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import BarChartIcon from "@mui/icons-material/BarChart";
import PeopleIcon from "@mui/icons-material/People";
import CampaignIcon from "@mui/icons-material/Campaign";
import DashboardCharts from "./DashboardCharts";

const Dashboard = () => {
  const stats = [
    { title: "Total Sales", value: "$12,345", trend: "↑5%", icon: <BarChartIcon fontSize="large" /> },
    { title: "New Users", value: "123", trend: "↑10%", icon: <PeopleIcon fontSize="large" /> },
    { title: "Active Campaigns", value: "8", trend: "↓15%", icon: <CampaignIcon fontSize="large" /> },
  ];

  const goals = {
    "Total Sales": 20000,
    "New Users": 150,
    "Active Campaigns": 10,
  };

  return (
    <Box sx={{ padding: { xs: 2, md: 4 } }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: { xs: 2, md: 4 },
          backgroundColor: "#ffffff",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
          mb: 3,
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Dashboard
        </Typography>
      </Box>

      {/* Stats Cards */}
      <Grid container spacing={3}>
        {stats.map((stat, index) => {
          const goal = goals[stat.title];
          const isGoalMet = parseInt(stat.value.replace(/[^0-9]/g, ""), 10) >= goal;

          return (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  padding: 2,
                  display: "flex",
                  alignItems: "center",
                  background: isGoalMet
                    ? "linear-gradient(135deg, #e3f2fd, #ffffff)"
                    : "linear-gradient(135deg, #ffebee, #ffffff)",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: 3,
                  cursor: "pointer",
                  ":hover": {
                    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                    transform: "scale(1.02)",
                  },
                }}
              >
                {stat.icon}
                <CardContent sx={{ ml: 2 }}>
                  <Typography variant="h6">{stat.title}</Typography>
                  <Typography variant="h3">{stat.value}</Typography>
                  <Typography
                    variant="body2"
                    color={isGoalMet ? "green" : "red"}
                  >
                    {isGoalMet
                      ? "Goal Met!"
                      : `Goal: ${goal.toLocaleString()} remaining`}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {/* Charts */}
      <Box
        sx={{
          mt: 5,
          p: 3,
          background: "#ffffff",
          borderRadius: 2,
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <DashboardCharts />
      </Box>
    </Box>
  );
};

export default Dashboard;
